import { useEffect, useCallback } from 'react';

interface UseUnsavedChangesOptions {
  isDirty: boolean;
  message?: string;
}

export function useUnsavedChanges({
  isDirty,
  message = 'You have unsaved changes. Are you sure you want to leave?',
}: UseUnsavedChangesOptions) {
  // Warn on browser close/refresh
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty, message]);

  // Guard for in-app navigation (cancel buttons, back buttons)
  const confirmNavigation = useCallback(
    (callback: () => void) => {
      if (isDirty) {
        if (window.confirm(message)) {
          callback();
        }
      } else {
        callback();
      }
    },
    [isDirty, message]
  );

  return { confirmNavigation };
}
